import React, { createContext, useEffect, useState } from "react";
import { NamedProperty } from "sprint-common-web";

import { GetLanguageSpecificationsLookupResponse } from "../../api/orders-api/language-specification/responses/GetLanguageSpecificationsLookupResponse";
import { useLanguageSpecificationApi } from "../../api/orders-api/language-specification/useLanguageSpecificationApi";
import { LanguageSpecification, mapToLanguageSpecification } from "../../types/LanguageSpecification";

interface ILanguageSpecificationsDataContext {
    languageSpecifications: NamedProperty[];
    isLoading: boolean;
}

export const LanguageSpecificationsDataContext = createContext<ILanguageSpecificationsDataContext>({
    languageSpecifications: [],
    isLoading: true
});

export const LanguageSpecificationsDataProvider: React.FC = ({ children }) => {
    const [languageSpecifications, setLanguageSpecifications] = useState<LanguageSpecification[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const { getLanguageSpecificationsLookup } = useLanguageSpecificationApi();

    useEffect(() => {
        setIsLoading(true);

        getLanguageSpecificationsLookup()
            .then((response: GetLanguageSpecificationsLookupResponse) => {
                const languageSpecificationsList = response.items.map(mapToLanguageSpecification);

                setLanguageSpecifications(languageSpecificationsList);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <LanguageSpecificationsDataContext.Provider value={{ languageSpecifications, isLoading }}>
            {children}
        </LanguageSpecificationsDataContext.Provider>
    );
};
